import React, { useEffect } from "react";
import {
  makeStyles,
  Grid,
  Divider,
  Button,
  Chip,
  Container,
  Box,
  Card,
  CardContent,
  CardHeader,
} from "@material-ui/core";

import MaterialTable from "material-table";
import { useHistory } from "react-router-dom";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import { useSelector, useDispatch } from "react-redux";
import { createPurchaseRequest } from "src/redux/actions/purchaseRequest.action";
import { AlertTitle, Alert } from "@material-ui/lab";
import { blue, green, blueGrey } from "@material-ui/core/colors";
import _ from "lodash";
import { hasRole, isAllowed } from "src/utils/Auth";
import {
  fetchCurrencies,
  findAllBrand,
  findAllDepartment,
  getAllCountries,
} from "src/redux/actions/reference.action";
import Page from "src/components/Page";
import Moment from "moment";
import currencyjs from "currency.js";
import { httpClient } from "src/utils/HttpClient";
import { apiUrl } from "src/Constants";
import moment from "moment";
import StatusLabel from "src/components/StatusLabel";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

const PRListApproverPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    result: {
      countryid,
      fullname,
      companyid,
      currencyid,
      brand_id,
      department_id,
      perid,
      email,
      secureid,
    },
  } = useSelector((state) => state.loginReducer);

  const { purchaseRequests } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const { authorizePR } = useSelector((state) => state.authorizationReducer);
  const { countries, allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );

  useEffect(() => {
    // if (
    //   hasRole(authorizePR.data, ["staff"]) &&
    //   !hasRole(authorizePR.data, ["super-admin"])
    // ) {
    //   // dispatch(getPurchaseRequestStaff(countryid));
    // } else if (hasRole(authorizePR.data, ["super-admin", "admin"])) {
    //   // dispatch(getPurchaseRequestAdmin());
    // } else if (hasRole(authorizePR.data, ["manager"])) {
    //   // dispatch(
    //   //   getPurchaseRequestManager(brand_id, department_id, countryid, perid)
    //   // );
    // } else if (hasRole(authorizePR.data, ["user"])) {
    //   // dispatch(getPurchaseRequestUser(brand_id, department_id, countryid));
    // }

    dispatch(getAllCountries());
    dispatch(fetchCurrencies(currencyid));
    dispatch(findAllDepartment());
    dispatch(findAllBrand());
  }, []);

  if (purchaseRequests.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Purchase Requisition data!</strong>
        </Alert>
      </div>
    );
  }

  const hasEdit = (data, status) => {
    if (data.PR_STATUS !== undefined) {
      return status.some((s) => data.PR_STATUS === s);
    }
  };

  const sumTotalPrice = (value) => {
    let totalAmount = _(value.PR_Ds)
      .groupBy("PRHIDX")
      .map((objs, key) => {
        return _.sumBy(objs, "AMOUNT");
      })
      .value();

    let totalExpense = _(value.PR_EXPENSEs)
      .groupBy("PRHIDX")
      .map((objs, key) => {
        return _.sumBy(objs, "AMOUNT");
      })
      .value();

    return Number(totalAmount) + Number(totalExpense);
  };

  const sumTotalOriginalPrice = (value) => {
    const totalCosts = _.sumBy(value.PR_Ds, (i) => {
      return i.PRICE * i.QTY;
    });
    return Number(totalCosts);
  };

  const renderLookupBrand = () => {
    if (allBrands.data) {
      let obj = allBrands.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const renderLookupDepartment = () => {
    if (allDepartments.data) {
      let obj = allDepartments.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  return (
    <Page className={classes.root} title="Purchase Requisition For Approver">
      <Container maxWidth={false}>
        <Card>
          <CardHeader subheader="" title="Purchase Requisition For Approver" />
          <Divider />
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Box flexGrow={1}>
                <MaterialTable
                  title
                  isLoading={purchaseRequests.isLoading}
                  columns={[
                    {
                      title: "PR NO.",
                      field: "PR_NO",
                    },
                    {
                      title: "Request Date",
                      field: "CREATED_DATE",
                      type: "date",
                      render: (rowData) =>
                        Moment(rowData.CREATED_DATE).format("DD-MMM-YY"),
                    },
                    {
                      title: "Brand",
                      field: "PR_BRANDID",
                      lookup: renderLookupBrand(),
                    },
                    {
                      title: "Department",
                      field: "PR_DEPARTID",
                      lookup: renderLookupDepartment(),
                    },
                    { title: "Requester", field: "CREATED_NAME" },
                    {
                      title: "Assigned Approver",
                      field: "ASSIGN_APPROVE_NAME",
                    },
                    {
                      title: "Status",
                      field: "PR_STATUS",
                      lookup: {
                        22: "REVIEWED",
                        35: "HELD BY APPROVER",
                      },
                      render: (rowData) => (
                        <>
                          <StatusLabel status={rowData.PR_STATUS} />
                        </>
                      ),
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      let url = `${apiUrl}/purchase-request/approver?countryid=${countryid}&userid=${perid}`;

                      url += "&per_page=" + query.pageSize;
                      url += "&page=" + query.page;
                      url += "&search=" + query.search;

                      if (query.filters.length) {
                        query.filters.map(({ column, value }) => {
                          if (column.field === "CREATED_DATE") {
                            value = moment(value).format("YYYY-MM-DD");
                          }
                          url += `&${column.field}=${value}`;
                        });
                      }

                      if (query.orderBy) {
                        url += `&orderby=${query.orderBy.field},${query.orderDirection}`;
                      }

                      httpClient.get(url).then(({ data }) => {
                        resolve({
                          data: data.rows,
                          page: query.page,
                          totalCount: data.count,
                        });
                      });
                    })
                  }
                  actions={[
                    (rowData) => ({
                      icon: "comment",
                      tooltip: "Purchase Requisition Comment",
                      hidden: Boolean(
                        rowData.PR_STATUS === 10 ||
                          rowData.PR_STATUS === 20 ||
                          rowData.PR_STATUS === 30
                      ),
                      onClick: (event, rowData) => {
                        event.preventDefault();
                        history.push(
                          `purchase-requisition-remark/${rowData.PRHIDX}/${rowData.PR_NO}`
                        );
                      },
                    }),
                    (rowData) => ({
                      icon: "edit",
                      tooltip: "View Purchase Requisition",
                      onClick: (event, rowData) => {
                        event.preventDefault();
                        history.push(`edit-pr-approver/${rowData.PRHIDX}`);
                      },
                    }),
                  ]}
                  detailPanel={[
                    (rowData) => ({
                      icon: "storage",
                      tooltip: "Detail of the PO generated",
                      disabled: Boolean(rowData.PR_STATUS < 100),
                      render: (rowData) => {
                        return (
                          <Card>
                            <CardContent>
                              <MaterialTable
                                title
                                columns={[
                                  {
                                    title: "PO NO.",
                                    field: "PO_NO",
                                  },
                                  {
                                    title: "ITEM",
                                    field: "ITEMS_DETAIL",
                                  },
                                  {
                                    title: "TYPE",
                                    field: "PO_TYPE",
                                    render: (rowData) => {
                                      return rowData.PO_TYPE === 1
                                        ? "(PO Generate)"
                                        : "(Not Generate)";
                                    },
                                  },
                                  {
                                    title: "CREATE DATE",
                                    field: "CREATED_AT",
                                    type: "date",
                                    render: (rowData) =>
                                      Moment(rowData.CREATED_AT).format(
                                        "DD-MMM-YY"
                                      ),
                                  },
                                ]}
                                data={rowData.PR_D_JOBs}
                                options={{
                                  filtering: false,
                                }}
                              />
                            </CardContent>
                          </Card>
                        );
                      },
                    }),
                  ]}
                  options={{
                    filtering: true,
                    search: true,
                    showFirstLastPageButtons: false,
                  }}
                  style={{
                    width: "100%",
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default PRListApproverPage;
